export const SVGEventTranslation = {
	getSVG(element: Node): SVGSVGElement {
		while (element.parentNode != null) {
			if (element.nodeName === 'svg') {
				return <SVGSVGElement>element;
			}
			element = element.parentNode;
		}
		return null;
	},

	translatePoint(point: SVGPoint, ctm: SVGMatrix): SVGPoint {
		return point.matrixTransform(ctm.inverse());
	},

	translateXY(x: number, y: number, element: Node): SVGPoint {
		var svg = SVGEventTranslation.getSVG(element);
		if (svg == null) {
			return null;
		}

		var matrix = svg.getScreenCTM();
		var point = svg.createSVGPoint();

		point.x = x;
		point.y = y;

		return SVGEventTranslation.translatePoint(point, matrix);
	},

	translateEvent(evt: MouseEvent) {
		return SVGEventTranslation.translateXY(evt.clientX, evt.clientY, <Node>evt.target);
	},
};
